<script>
import mixins from "../../mixins/index";
import { BaseSelect } from "@/components";
export default {
  name: "AccordionSubItemAlgoServer",
  mixins: [mixins],
  components: { BaseSelect },
  props: {
    item: Object,
    dataItem: Object,
    isResponsive: Boolean,
  },
  computed: {
    check() {
      return this.dataItem?.algorithm?.find(
        (o) => o.algorithmFeature.id === this.item.id
      );
    },
  },
  methods: {
    changeActive() {
      const newCheckedValue = !this.checked;
      this.showSelectbox = !this.showSelectbox;
      this.checked = newCheckedValue;
      return newCheckedValue;
    },
    changeAlgoServer(item) {
      const args = {
        ...item,
        dateSelection: this.startDateSelection,
      };
      this.$emit("changeAlgoServerItems", args);
      this.changeActive();
    },
    changeStartDate(value) {
      this.startDateSelection = value.code;
      const args = {
        ...this.item,
        dateSelection: this.startDateSelection,
      };
      this.$emit("changeAlgoServerItems", args);
    },
    checkStartDateByRow() {
      const getStartDate = this.dataItem.algorithm.find(
        (o) => o.algorithmFeature.id === this.item.id
      );
      if (getStartDate != undefined) {
        this.startDateSelection = Number(getStartDate.dateSelection.key);
        this.showSelectbox = true;
      }
    },
  },
  mounted() {
    if (this.check) {
      this.changeActive();
      this.checkStartDateByRow();
      const args = {
        ...this.item,
        dateSelection: this.item?.dateSelection
          ? this.item?.dateSelection
          : this.startDateSelection,
      };
      this.$emit("changeAlgoServerItems", args);
    }
  },
  data() {
    return {
      checked: false,
      itemName: this.item?.name,
      itemFundAmount: this.item?.fundAmount,
      itemCommissionAmount: this.item?.commissionAmount,
      itemPriceInfo: this.item?.priceInfo,
      itemPrice: this.item?.price,
      showSelectbox: false,
      startDateSelection: -1,
      startDate: [
        {
          label: "Seçiniz",
          code: -1,
        },
        {
          label: "Hemen",
          code: 0,
        },
        {
          label: "Ay Başında",
          code: 1,
        },
      ],
    };
  },
};
</script>
<template>
  <tr v-if="!isResponsive" :class="checked ? 'active' : ''">
    <td>
      <input
        type="checkbox"
        :id="itemName"
        class="base-form-checkbox"
        :checked="check && 'checked'"
        @change="changeAlgoServer(item)"
      />
    </td>
    <td>
      {{ itemName }}
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="itemFundAmount">
        BES / Komisyon: {{ formatPrice(itemFundAmount) }}&nbsp;TL /
        {{ formatPrice(itemCommissionAmount) }}&nbsp;TL
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td>
      <div class="table-dropdown m-flex" v-if="itemPrice">
        {{ itemPrice }}
        <span v-if="itemPriceInfo == '₺'"> TL </span>
        <span v-if="itemPriceInfo == '$'"> USD </span>
        <span v-if="itemPriceInfo == '€'"> EUR </span>
      </div>
      <div v-else class="text-center">-</div>
    </td>
    <td v-if="showSelectbox">
      <label :for="`startDate-${item.id}`">Başlangıç zamanı</label>
      <base-select
        fieldLabel="Başlangıç Zamanı"
        :options="startDate"
        id="startTime"
        @change="changeStartDate"
        :selectedId="startDateSelection"
        placeholder="Seçiniz"
        class="start-date-select"
      />
    </td>
    <td v-else>-</td>
  </tr>
  <div
    v-else
    class="responsive-table-container"
    :class="checked ? 'highlight' : ''"
  >
    <div class="mobile-wrap">
      <label class="row caption" :for="'input-' + item.marketId">
        <input
          type="checkbox"
          :id="itemName"
          class="base-form-checkbox"
          :checked="check && 'checked'"
          @change="changeAlgoServer(item)"
        />
        {{ itemName }}
      </label>
      <div class="row inline">
        <span>BES / Komisyon</span>
        <div v-if="itemFundAmount && itemCommissionAmount">
          {{ formatPrice(itemFundAmount) }}&nbsp;TL /
          {{ formatPrice(itemCommissionAmount) }}&nbsp;TL
        </div>
        <div class="no-data" v-else>-</div>
      </div>
      <div class="row">
        <span v-if="itemPriceInfo == '₺'">{{ itemPrice }} TL </span>
        <span v-else-if="itemPriceInfo == '$'">{{ itemPrice }} USD </span>
        <span v-else-if="itemPriceInfo == '€'">{{ itemPrice }} EUR </span>
      </div>
      <div class="row">
        <span class="title" v-if="this.$route.query.isRecommended === undefined"
          >Başlangıç Zamanı</span
        >
        <base-select
          fieldLabel="Başlangıç Zamanı"
          :options="startDate"
          v-if="showSelectbox"
          :id="`startDate-${item.id}`"
          @change="changeStartDate"
          :selectedId="startDateSelection"
          placeholder="Seçiniz"
          class="start-date-select"
        />
        <div class="no-data" v-else>-</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active {
  background-color: #f9f9fa;
  border-radius: 13px;
}
.responsive-table-container {
  width: 100%;
  .data-container {
    @media (max-width: 460px) {
      width: 65%;
    }
  }
  .title-container {
    font-size: 12px;
    @media (max-width: 460px) {
      width: 35%;
    }
  }
}

.bold {
  font-weight: 700;
}
</style>
